var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"value-list"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index},[_c('span',{staticClass:"font-weight-light mr-1"},[_vm._v(_vm._s(item.name)+":")]),(item.value)?[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.value))])]:[_vm._v(" - ")]],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }